"use client"

import { Link } from "react-router-dom";
import LuminodeBlack from "./svg/LuminodeBlack";
import { HEADER_SIZE } from "./NewHeader";

// Lift + brand glow on hover, settle back on press. The lift is skipped for
// users who prefer reduced motion; the glow and color shift still apply.
const BUTTON_CLASSES =
  "block bg-luminode-blue text-black text-[14px] py-[8px] px-[16px] font-semibold cursor-pointer " +
  "transition-[translate,box-shadow,background-color] duration-300 ease-[cubic-bezier(0.22,1,0.36,1)] " +
  "hover:bg-[#4d9aff] hover:shadow-[0_10px_28px_-8px_rgba(54,141,255,0.75)] motion-safe:hover:-translate-y-[2px] " +
  "active:translate-y-0 active:shadow-[0_4px_12px_-6px_rgba(54,141,255,0.6)] active:duration-100";

function LButton({ children, click_cb, luminodeicon = false, push_down = false, href }: any) {

  let li = luminodeicon ? <LuminodeBlack /> : <></>

  const clickHandler = (e: any) => {
    e.preventDefault();
    if (click_cb) {
      click_cb();
    };
    if (push_down) {
      const target = document.getElementById("work-with-us");
      if (target) {
        // Offset by the header's actual rendered height (it varies with viewport
        // width) plus a small gap, so the section's subtitle isn't tucked behind
        // the sticky header. Falls back to HEADER_SIZE if the header isn't found.
        const header = document.getElementById("app-header");
        const headerHeight = header
          ? header.getBoundingClientRect().height
          : HEADER_SIZE;
        const gap = 16;
        const to =
          window.scrollY +
          target.getBoundingClientRect().top -
          headerHeight -
          gap;
        window.scrollTo({ top: Math.max(0, to), behavior: "smooth" });
      }
    }
  }
  const content = (
    <div className="flex flex-row items-center gap-4 p-1">
      {li}
      {children}
    </div>
  );
  if (href) {
    return (
      <Link to={href} className={BUTTON_CLASSES}>
        {content}
      </Link>
    );
  }
  return (
    <div
      className={BUTTON_CLASSES}
      onClick={clickHandler}
    >
      {content}
    </div>
  );
}

export default LButton;